import {
	type Control,
	Controller,
	type FieldPathByValue,
	type FieldValues,
} from "react-hook-form";
import { DocumentFileField } from "web_myplann/Portfolio/Forms/DocumentUploadForm/DocumentFileField";
import type { PickedFile } from "web_myplann/Portfolio/Forms/DocumentUploadForm/documentUploadFormSchema";

type Props<
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: FieldPathByValue<FormType, PickedFile | null>;
	disabled: boolean;
	onValueChange?: (
		next: PickedFile | null,
		previous: PickedFile | null,
	) => void;
};

export const DocumentFileFormField = <
	FormType extends FieldValues,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	disabled,
	onValueChange,
}: Props<FormType, TContext, TTransformed>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange }, fieldState: { error } }) => (
			<DocumentFileField
				value={value}
				disabled={disabled}
				errorMessage={error?.message}
				onChange={(next) => {
					onChange(next);
					onValueChange?.(next, value);
				}}
			/>
		)}
	/>
);
